import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { initLenis, scrollToId } from "@/lib/lenis";
import { wcApi } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Catalog from "@/components/Catalog";
import Manifesto from "@/components/Manifesto";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ProductPage from "@/pages/ProductPage";

import LegalPage from "@/pages/LegalPage";
import PrivacyPage from "@/pages/PrivacyPage";

const Home = () => {
  const [products, setProducts] = useState([]);
  const location = useLocation();

  useEffect(() => {
    initLenis();
    if (location.state?.to) {
      const timers = [40, 250, 600].map((ms) => setTimeout(() => scrollToId(location.state.to, true), ms));
      return () => timers.forEach(clearTimeout);
    }
    return undefined;
  }, [location.state]);

  useEffect(() => {
    wcApi
      .get("/products")
      .then((r) => {
        // Map WooCommerce products to the React App format
        const mappedProducts = r.data.map(wpProd => ({
          id: wpProd.id.toString(), // The React router expects a string ID
          name: wpProd.name,
          category: wpProd.categories?.[0]?.name || "Uncategorized",
          price: (wpProd.prices.price / (10 ** wpProd.prices.currency_minor_unit)).toFixed(2),
          anomaly_class: wpProd.attributes?.find(a => a.name === "anomaly_class")?.terms?.[0]?.name || "CLASS-C",
          signature: wpProd.attributes?.find(a => a.name === "signature")?.terms?.[0]?.name === "True",
          image: wpProd.images?.[0]?.src || "/products/placeholder.png",
          video_loop: null, // Set up ACF in WP for this later
          description: wpProd.short_description ? wpProd.short_description.replace(/<[^>]+>/g, '') : "",
        }));
        setProducts(mappedProducts);
      })
      .catch((e) => console.error("catalog fetch failed", e));
  }, []);

  return (
    <div className="min-h-screen bg-void font-mono text-ink">
      <Navbar />
      <main>
        <Hero />
        <Catalog products={products} />
        <Manifesto />
        <Footer />
      </main>
      <CartDrawer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/impressum" element={<LegalPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-left"
          theme="dark"
          toastOptions={{
            style: {
              background: "#081b24",
              border: "1px solid rgba(0,240,255,0.35)",
              color: "#e2f8ff",
              fontFamily: "'JetBrains Mono', monospace",
              borderRadius: 0,
            },
          }}
        />
      </CartProvider>
    </div>
  );
}

export default App;
